import { createContext, useContext } from 'react';

/**
 * True when AppLayout applies horizontal `px={4}` on mobile.
 * False when the shell is flushed for full-bleed browse/hero routes —
 * negative-margin breakouts must not run (they would overshoot the viewport),
 * and page chrome should add its own gutter instead.
 */
const MobileShellPaddedContext = createContext(true);

export const MobileShellPaddedProvider = MobileShellPaddedContext.Provider;

/** Whether the mobile AppLayout shell still has horizontal content padding. */
export function useMobileShellPadded(): boolean {
  return useContext(MobileShellPaddedContext);
}

/**
 * Mobile bottom clearance for scrollable page content (tab bar ± filter FAB).
 * Provided by AppLayout; applied inside MobileTabKeepAlive panels so absolute
 * keep-alive layers still clear the fixed nav when the window scrolls.
 */
const MobileShellBottomPaddingContext = createContext('16px');

export const MobileShellBottomPaddingProvider = MobileShellBottomPaddingContext.Provider;

/** CSS length for mobile content `padding-bottom` under the fixed chrome. */
export function useMobileShellBottomPadding(): string {
  return useContext(MobileShellBottomPaddingContext);
}
